
export const CountryPhoneCodeList = [
    {
        code: '1',
        countryName: 'United States',
    },
    {
        code: '1',
        countryName: 'Canada',
    },
    {
        code: '93',
        countryName: 'Afghanistan',
    },
    {
        code: '355',
        countryName: 'Albania',
    },
    {
        code: '213',
        countryName: 'Algeria',
    },
    {
        code: '1-684',
        countryName: 'American Samoa',
    },
    {
        code: '376',
        countryName: 'Andorra',
    },
    {
        code: '244',
        countryName: 'Angola',
    },
    {
        code: '1-264',
        countryName: 'Anguilla',
    },
    {
        code: '6721',
        countryName: 'Antarctica - Australian bases',
    },
    {
        code: '268',
        countryName: 'Antigua and Barbuda',
    },
    {
        code: '54',
        countryName: 'Argentina',
    },
    {
        code: '374',
        countryName: 'Armenia',
    },
    {
        code: '297',
        countryName: 'Aruba',
    },
    {
        code: '247',
        countryName: 'Ascension',
    },
    {
        code: '61',
        countryName: 'Australia',
    },
    {
        code: '43',
        countryName: 'Austria',
    },
    {
        code: '994',
        countryName: 'Azerbaijan',
    },
    {
        code: '1-242',
        countryName: 'Bahamas',
    },
    {
        code: '973',
        countryName: 'Bahrain',
    },
    {
        code: '880',
        countryName: 'Bangladesh',
    },
    {
        code: '1-246',
        countryName: 'Barbados',
    },
    {
        code: '375',
        countryName: 'Belarus',
    },
    {
        code: '32',
        countryName: 'Belgium',
    },
    {
        code: '501',
        countryName: 'Belize',
    },
    {
        code: '229',
        countryName: 'Benin',
    },
    {
        code: '1-441',
        countryName: 'Bermuda',
    },
    {
        code: '975',
        countryName: 'Bhutan',
    },
    {
        code: '591',
        countryName: 'Bolivia',
    },
    {
        code: '599',
        countryName: 'Bonaire, Sint Eustatius and Saba',
    },
    {
        code: '387',
        countryName: 'Bosnia and Herzegovina',
    },
    {
        code: '267',
        countryName: 'Botswana',
    },
    {
        code: '55',
        countryName: 'Brazil',
    },
    {
        code: '246',
        countryName: 'British Indian Ocean Territory',
    },
    {
        code: '1-284',
        countryName: 'British Virgin Islands',
    },
    {
        code: '673',
        countryName: 'Brunei',
    },
    {
        code: '359',
        countryName: 'Bulgaria',
    },
    {
        code: '226',
        countryName: 'Burkina Faso',
    },
    {
        code: '257',
        countryName: 'Burundi',
    },
    {
        code: '238',
        countryName: 'Cabo Verde',
    },
    {
        code: '855',
        countryName: 'Cambodia',
    },
    {
        code: '237',
        countryName: 'Cameroon',
    },
    {
        code: '1-345',
        countryName: 'Cayman Islands',
    },
    {
        code: '236',
        countryName: 'Central African Republic',
    },
    {
        code: '235',
        countryName: 'Chad',
    },
    {
        code: '56',
        countryName: 'Chile',
    },
    {
        code: '86',
        countryName: 'China',
    },
    {
        code: '57',
        countryName: 'Colombia',
    },
    {
        code: '269',
        countryName: 'Comoros',
    },
    {
        code: '243',
        countryName: 'Congo, Democratic Republic of the',
    },
    {
        code: '242',
        countryName: 'Congo, Republic of the',
    },
    {
        code: '682',
        countryName: 'Cook Islands',
    },
    {
        code: '506',
        countryName: 'Costa Rica',
    },
    {
        code: '225',
        countryName: 'Cote d\'Ivoire',
    },
    {
        code: '385',
        countryName: 'Croatia',
    },
    {
        code: '53',
        countryName: 'Cuba',
    },
    {
        code: '599',
        countryName: 'Curaçao',
    },
    {
        code: '357',
        countryName: 'Cyprus',
    },
    {
        code: '420',
        countryName: 'Czech Republic',
    },
    {
        code: '45',
        countryName: 'Denmark',
    },
    {
        code: '253',
        countryName: 'Djibouti',
    },
    {
        code: '767',
        countryName: 'Dominica 1',
    },
    {
        code: '1-809',
        countryName: 'Dominican Republic - 1-809',
    },
    {
        code: '1-829',
        countryName: 'Dominican Republic - 1 829',
    },
    {
        code: '1-849',
        countryName: 'Dominican Republic - 1 849',
    },
    {
        code: '593',
        countryName: 'Ecuador',
    },
    {
        code: '20',
        countryName: 'Egypt',
    },
    {
        code: '503',
        countryName: 'El Salvador',
    },
    {
        code: '240',
        countryName: 'Equatorial Guinea',
    },
    {
        code: '291',
        countryName: 'Eritrea',
    },
    {
        code: '372',
        countryName: 'Estonia',
    },
    {
        code: '268',
        countryName: 'Eswatini',
    },
    {
        code: '251',
        countryName: 'Ethiopia',
    },
    {
        code: '500',
        countryName: 'Falkland Islands',
    },
    {
        code: '298',
        countryName: 'Faroe Islands',
    },
    {
        code: '679',
        countryName: 'Fiji',
    },
    {
        code: '358',
        countryName: 'Finland',
    },
    {
        code: '33',
        countryName: 'France',
    },
    {
        code: '594',
        countryName: 'French Guiana',
    },
    {
        code: '689',
        countryName: 'French Polynesia',
    },
    {
        code: '241',
        countryName: 'Gabon',
    },
    {
        code: '220',
        countryName: 'Gambia',
    },
    {
        code: '970',
        countryName: 'Gaza Strip',
    },
    {
        code: '995',
        countryName: 'Georgia',
    },
    {
        code: '49',
        countryName: 'Germany',
    },
    {
        code: '233',
        countryName: 'Ghana',
    },
    {
        code: '350',
        countryName: 'Gibraltar',
    },
    {
        code: '30',
        countryName: 'Greece',
    },
    {
        code: '299',
        countryName: 'Greenland',
    },
    {
        code: '1-473',
        countryName: 'Grenada',
    },
    {
        code: '590',
        countryName: 'Guadeloupe',
    },
    {
        code: '1-671',
        countryName: 'Guam',
    },
    {
        code: '502',
        countryName: 'Guatemala',
    },
    {
        code: '224',
        countryName: 'Guinea',
    },
    {
        code: '245',
        countryName: 'Guinea-Bissau',
    },
    {
        code: '592',
        countryName: 'Guyana',
    },
    {
        code: '509',
        countryName: 'Haiti',
    },
    {
        code: '504',
        countryName: 'Honduras',
    },
    {
        code: '852',
        countryName: 'Hong Kong',
    },
    {
        code: '36',
        countryName: 'Hungary',
    },
    {
        code: '354',
        countryName: 'Iceland',
    },
    {
        code: '91',
        countryName: 'India',
    },
    {
        code: '62',
        countryName: 'Indonesia',
    },
    {
        code: '964',
        countryName: 'Iraq',
    },
    {
        code: '98',
        countryName: 'Iran',
    },
    {
        code: '353',
        countryName: 'Ireland',
    },
    {
        code: '972',
        countryName: 'Israel',
    },
    {
        code: '39',
        countryName: 'Italy',
    },
    {
        code: '1-876',
        countryName: 'Jamaica - 1 876',
    },
    {
        code: '1-658',
        countryName: 'Jamaica - 1 658',
    },
    {
        code: '81',
        countryName: 'Japan',
    },
    {
        code: '962',
        countryName: 'Jordan',
    },
    {
        code: '7',
        countryName: 'Kazakhstan',
    },
    {
        code: '254',
        countryName: 'Kenya',
    },
    {
        code: '686',
        countryName: 'Kiribati',
    },
    {
        code: '383',
        countryName: 'Kosovo',
    },
    {
        code: '965',
        countryName: 'Kuwait',
    },
    {
        code: '996',
        countryName: 'Kyrgyzstan',
    },
    {
        code: '856',
        countryName: 'Laos',
    },
    {
        code: '371',
        countryName: 'Latvia',
    },
    {
        code: '961',
        countryName: 'Lebanon',
    },
    {
        code: '266',
        countryName: 'Lesotho',
    },
    {
        code: '231',
        countryName: 'Liberia',
    },
    {
        code: '218',
        countryName: 'Libya',
    },
    {
        code: '423',
        countryName: 'Liechtenstein',
    },
    {
        code: '370',
        countryName: 'Lithuania',
    },
    {
        code: '352',
        countryName: 'Luxembourg',
    },
    {
        code: '853',
        countryName: 'Macau',
    },
    {
        code: '261',
        countryName: 'Madagascar',
    },
    {
        code: '265',
        countryName: 'Malawi',
    },
    {
        code: '60',
        countryName: 'Malaysia',
    },
    {
        code: '960',
        countryName: 'Maldives',
    },
    {
        code: '223',
        countryName: 'Mali',
    },
    {
        code: '356',
        countryName: 'Malta',
    },
    {
        code: '692',
        countryName: 'Marshall Islands',
    },
    {
        code: '596',
        countryName: 'Martinique',
    },
    {
        code: '222',
        countryName: 'Mauritania',
    },
    {
        code: '230',
        countryName: 'Mauritius',
    },
    {
        code: '262',
        countryName: 'Mayotte',
    },
    {
        code: '52',
        countryName: 'Mexico',
    },
    {
        code: '691',
        countryName: 'Micronesia',
    },
    {
        code: '373',
        countryName: 'Moldova',
    },
    {
        code: '377',
        countryName: 'Monaco',
    },
    {
        code: '976',
        countryName: 'Mongolia',
    },
    {
        code: '382',
        countryName: 'Montenegro',
    },
    {
        code: '1-664',
        countryName: 'Montserrat',
    },
    {
        code: '212',
        countryName: 'Morocco',
    },
    {
        code: '258',
        countryName: 'Mozambique',
    },
    {
        code: '95',
        countryName: 'Myanmar',
    },
    {
        code: '264',
        countryName: 'Namibia',
    },
    {
        code: '674',
        countryName: 'Nauru',
    },
    {
        code: '31',
        countryName: 'Netherlands',
    },
    {
        code: '977',
        countryName: 'Nepal',
    },
    {
        code: '687',
        countryName: 'New Caledonia',
    },
    {
        code: '64',
        countryName: 'New Zealand',
    },
    {
        code: '505',
        countryName: 'Nicaragua',
    },
    {
        code: '227',
        countryName: 'Niger',
    },
    {
        code: '234',
        countryName: 'Nigeria',
    },
    {
        code: '683',
        countryName: 'Niue',
    },
    {
        code: '6723',
        countryName: 'Norfolk Island',
    },
    {
        code: '850',
        countryName: 'North Korea',
    },
    {
        code: '389',
        countryName: 'North Macedonia',
    },
    {
        code: '28',
        countryName: 'Northern Ireland 44',
    },
    {
        code: '1-670',
        countryName: 'Northern Mariana Islands',
    },
    {
        code: '47',
        countryName: 'Norway',
    },
    {
        code: '968',
        countryName: 'Oman',
    },
    {
        code: '92',
        countryName: 'Pakistan',
    },
    {
        code: '680',
        countryName: 'Palau',
    },
    {
        code: '970',
        countryName: 'Palestine',
    },
    {
        code: '507',
        countryName: 'Panama',
    },
    {
        code: '675',
        countryName: 'Papua New Guinea',
    },
    {
        code: '595',
        countryName: 'Paraguay',
    },
    {
        code: '51',
        countryName: 'Peru',
    },
    {
        code: '63',
        countryName: 'Philippines',
    },
    {
        code: '48',
        countryName: 'Poland',
    },
    {
        code: '351',
        countryName: 'Portugal',
    },
    {
        code: '1-939',
        countryName: 'Puerto Rico - 1 939',
    },
    {
        code: '1-787',
        countryName: 'Puerto Rico - 1 787',
    },
    {
        code: '974',
        countryName: 'Qatar',
    },
    {
        code: '262',
        countryName: 'Reunion',
    },
    {
        code: '40',
        countryName: 'Romania',
    },
    {
        code: '7',
        countryName: 'Russia',
    },
    {
        code: '250',
        countryName: 'Rwanda',
    },
    {
        code: '590',
        countryName: 'Saint-Barthélemy',
    },
    {
        code: '290',
        countryName: 'Saint Helena and Tristan da Cunha',
    },
    {
        code: '1-869',
        countryName: 'Saint Kitts and Nevis',
    },
    {
        code: '1-758',
        countryName: 'Saint Lucia',
    },
    {
        code: '590',
        countryName: 'Saint Martin',
    },
    {
        code: '508',
        countryName: 'Saint Pierre and Miquelon',
    },
    {
        code: '1-784',
        countryName: 'Saint Vincent and the Grenadines',
    },
    {
        code: '685',
        countryName: 'Samoa',
    },
    {
        code: '239',
        countryName: 'Sao Tome and Principe',
    },
    {
        code: '966',
        countryName: 'Saudi Arabia',
    },
    {
        code: '221',
        countryName: 'Senegal',
    },
    {
        code: '381',
        countryName: 'Serbia',
    },
    {
        code: '248',
        countryName: 'Seychelles',
    },
    {
        code: '232',
        countryName: 'Sierra Leone',
    },
    {
        code: '1-721',
        countryName: 'Sint Maarten',
    },
    {
        code: '65',
        countryName: 'Singapore',
    },
    {
        code: '421',
        countryName: 'Slovakia',
    },
    {
        code: '386',
        countryName: 'Slovenia',
    },
    {
        code: '677',
        countryName: 'Solomon Islands',
    },
    {
        code: '252',
        countryName: 'Somalia',
    },
    {
        code: '27',
        countryName: 'South Africa',
    },
    {
        code: '82',
        countryName: 'South Korea',
    },
    {
        code: '211',
        countryName: 'South Sudan',
    },
    {
        code: '34',
        countryName: 'Spain',
    },
    {
        code: '94',
        countryName: 'Sri Lanka',
    },
    {
        code: '249',
        countryName: 'Sudan',
    },
    {
        code: '597',
        countryName: 'Suriname',
    },
    {
        code: '46',
        countryName: 'Sweden',
    },
    {
        code: '41',
        countryName: 'Switzerland',
    },
    {
        code: '963',
        countryName: 'Syria',
    },
    {
        code: '886',
        countryName: 'Taiwan',
    },
    {
        code: '992',
        countryName: 'Tajikistan',
    },
    {
        code: '255',
        countryName: 'Tanzania',
    },
    {
        code: '66',
        countryName: 'Thailand',
    },
    {
        code: '670',
        countryName: 'Timor-Leste',
    },
    {
        code: '228',
        countryName: 'Togo',
    },
    {
        code: '690',
        countryName: 'Tokelau',
    },
    {
        code: '676',
        countryName: 'Tonga',
    },
    {
        code: '1-868',
        countryName: 'Trinidad and Tobago',
    },
    {
        code: '216',
        countryName: 'Tunisia',
    },
    {
        code: '90',
        countryName: 'Turkey',
    },
    {
        code: '993',
        countryName: 'Turkmenistan',
    },
    {
        code: '1-649',
        countryName: 'Turks and Caicos Islands',
    },
    {
        code: '688',
        countryName: 'Tuvalu',
    },
    {
        code: '256',
        countryName: 'Uganda',
    },
    {
        code: '380',
        countryName: 'Ukraine',
    },
    {
        code: '971',
        countryName: 'United Arab Emirates',
    },
    {
        code: '44',
        countryName: 'United Kingdom',
    },
    {
        code: '598',
        countryName: 'Uruguay',
    },
    {
        code: '998',
        countryName: 'Uzbekistan',
    },
    {
        code: '678',
        countryName: 'Vanuatu',
    },
    {
        code: '58',
        countryName: 'Venezuela',
    },
    {
        code: '84',
        countryName: 'Vietnam',
    },
    {
        code: '1-340',
        countryName: 'U.S. Virgin Islands',
    },
    {
        code: '681',
        countryName: 'Wallis and Futuna',
    },
    {
        code: '970',
        countryName: 'West Bank',
    },
    {
        code: '967',
        countryName: 'Yemen',
    },
    {
        code: '260',
        countryName: 'Zambia',
    },
    {
        code: '263',
        countryName: 'Zimbabwe',
    },
]
